<template>
  <div class="collection-desc">
    <div
      class="author"
      v-html="nickInfo"
    />
    <div class="control-detail">
      <span class="desc">{{ desc }}</span>
      <strong
        v-if="topic.id"
        class="topic"
      >
        #{{ topic.name || topic.id }}</strong>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { toRefs, computed, ref, onMounted } from 'vue';
import { transferUbbToImg, encodeHtml } from '@/utils/string';
import { ModelMetaFeed } from '@/types/model';

// props
interface Props {
  feed: ModelMetaFeed,
}
const props = withDefaults(defineProps<Props>(), {
  feed: () => ({} as unknown as ModelMetaFeed),
});
const {
  feed,
} = toRefs(props);

// data
const nickInfo = ref('');

// computed
const desc = computed(() => {
  const { feedDescWithat: feedDesc, videoConfig } = feed.value;
  return videoConfig?.title || feedDesc;
});
const topic = computed(() => {
  const { videoConfig, topic, topicId } = feed.value;
  return {
    id: videoConfig?.tid || videoConfig?.tid || topicId,
    name: videoConfig?.topic?.topic_name || topic?.name,
  };
});
const poster = computed(() => (feed.value?.poster) || {});

nickInfo.value = encodeHtml(poster.value?.nick || `微视用户${feed.value.posterId || ''}`);

onMounted(() => {
  nickInfo.value = transferUbbToImg(encodeHtml(nickInfo.value));
});

</script>

<style lang="scss" scoped>
.collection-desc {
  position: absolute;
  z-index: 10;
  @include responsiveStyleSingle(bottom, 4.2667,'vw');
  @include responsiveStyleSingle(width, 72.2667,'vw');
  @include responsiveStyleSingle(margin-left, 2.6667,'vw');
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  color: #fff;
  transform: translateZ(0);
  .author {
    @include responsiveStyleSingle(margin-bottom, 0.5333, 'vw');
    font-weight: bold;
    @include responsiveStyleSingle(font-size, 3.7333, 'vw');
    @include responsiveStyleSingle(line-height, 5.3333, 'vw');
  }
  .control-detail {
    @include responsiveStyleSingle(font-size, 3.2, 'vw');
    @include responsiveStyleSingle(line-height, 4.8, 'vw');
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    .desc {
      margin-right: 5px;
    }
    .topic {
      @include responsiveStyleSingle(font-size, 3.2, 'vw');
      display: inline-block;
    }
  }
}
</style>
